import { AddressDetails, ShippingAddress } from '@/dto/api/prescription.dto'

export function shippingAddressToString (shippingAddress: ShippingAddress): string {
  if (shippingAddress == null) {
    return ''
  }

  return `${shippingAddress.street} ${shippingAddress.number}, ${shippingAddress.postalCode} ${shippingAddress.city}, ${shippingAddress.province}, España`
}

// Parses a Google Places result into a complete structured address.
// The whole breakdown is derived from the same `place`, so every field
// belongs to the same location — this prevents mixing fields from a
// previously stored address with a newly selected one.
export function placeToAddressDetails (place: google.maps.places.PlaceResult | null): AddressDetails {
  const get = (type: string): string =>
    place?.address_components?.find((component) => component.types.includes(type))?.long_name ?? ''

  return {
    street: get('route'),
    number: get('street_number'),
    postalCode: get('postal_code'),
    city: get('locality'),
    // Spain: level_2 is the province (e.g. "Zaragoza"); level_1 is the
    // autonomous community, used only as a fallback.
    province: get('administrative_area_level_2') !== '' ? get('administrative_area_level_2') : get('administrative_area_level_1'),
    country: get('country')
  }
}
